// @flow

import React, {Component} from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';
import {Themes, Sizes} from '../constants';
import {Star} from './star';
import styles from './star.module.styl';

import type {OnChangeRating} from '../typedef';
import type {Theme, Size} from '../constants';

const classNames = withCssModule(styles);

/**
 * Rating Props
 */
type RatingProps = {|
    /**
     * Additional classes for Rating
     */
    mix?: string,
    /**
     * Size of the Rating icon
     */
    size: Size,
    /**
     * Value of Rating
     */
    grade: number,
    /**
     * Style of Rating
     */
    theme: Theme,
    /**
     * Count of stars
     */
    quantity: number,
    /**
     * Rating is not clickable
     */
    readonly: boolean,
    /**
     * OnChange callback
     */
    onChange?: OnChangeRating,
|};

type State = {|
    hoverIndex: number,
|};

/**
 * The Rating component
 *
 * @component
 * @name Rating
 * @returns {HTMLDivElement}
 */
export class Rating extends Component<RatingProps, State> {
    static defaultProps = {
        grade: 0,
        quantity: 5,
        readonly: false,
        size: Sizes.size18,
        theme: Themes.blue
    };

    state = {
        hoverIndex: 0
    };

    onMouseLeave = () => {
        this.setState({hoverIndex: 0});
    };

    onMouseOverStar = (index: number) => {
        this.setState({hoverIndex: index});
    };

    onClickStar = (index: number) => {
        const {onChange} = this.props;

        if (onChange) {
            onChange(index);
        }
    };

    render() {
        const {hoverIndex} = this.state;
        const {mix, size, grade, theme, readonly, quantity} = this.props;
        const classes = classNames('rating', mix);

        return (
            <div className={classes} onMouseLeave={this.onMouseLeave}>
                {new Array(quantity).fill().map((item, i) => (
                    <Star
                        key={i}
                        index={i + 1}
                        grade={grade}
                        theme={theme}
                        size={size}
                        readonly={readonly}
                        hoverIndex={hoverIndex}
                        onClick={this.onClickStar}
                        onMouseOver={this.onMouseOverStar}
                    />
                ))}
            </div>
        );
    }
}

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");

require("../typedef");
